import Request from './../request';
import { IFaqResourceShort } from '../../props/faqs';

// import interfaces

const FaqService = {
  retrieve: async (): Promise<IFaqResourceShort[]> => {
    try {
      const results = await Request.get(`/api/faqs`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (data: FormData): Promise<IFaqResourceShort[]> => {
    try {
      const results = await Request.post(`/api/faqs`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  update: async (data: FormData, id: string): Promise<IFaqResourceShort[]> => {
    try {
      const results = await Request.post(`/api/faqs/${id}?_method=PUT`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  delete: async (id: string): Promise<IFaqResourceShort[]> => {
    try {
      const results = await Request.delete(`/api/faqs/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  reorder: async (data: FormData) => {
    try {
      const result = await Request.post(`/api/reorderProducts`, data, 'multipart/form-data');
      return result;
    } catch (error) {
      throw error;
    }
  },
};

export default FaqService;
